import React, { useState, useMemo, useEffect } from 'react';
import {
    Form,
    Input,
    Select,
    Button,
    Row,
    Col,
    Table,
    Modal,
    Space,
    Typography,
    Popconfirm
} from 'antd';
import type { PopconfirmProps, TableColumnsType, InputRef } from 'antd';
import {
    SearchOutlined,
    PrinterOutlined,
    DeleteOutlined,
    CaretUpOutlined,
    CaretDownOutlined
} from '@ant-design/icons';

import { apiRequest } from '../../../service/apiRequest';

import { showSuccess, showError } from '../../../components/errorHandler';

import useBillingShortcuts from '../../../hooks/useBillingShortcuts';

import useDebounce from '../../../hooks/useDebounce';
import debounce from 'lodash/debounce';
import AddJobModal from './AddJobModal';
import DiscountModal from './DiscountModal';
import PaymentDetails from './PaymentDetails';
import { useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import type { PD } from '../../../types/paymentDetail';

import type {
    Categories,
} from "../../../types/CreateProductType";

const { Option } = Select;
const { Title } = Typography;


interface clientItem {
    ledger_id: number;
    ledger_first_name: string;
    ledger_last_name: string;
    ledger_mobile_no: string;
    ledger_company_name: string;
    // ledger_company_gst_no: string;

    // Additional keys returned from your API
    reference_phone?: string;
    reference_name?: string;
    handover_phone?: string;
    handover_name?: string;
    invoice_category?: string;
    sale_employee_id?: number;


    ledger_gstin: string;
    active_cart: string;
    sale_id: string;

    sale_is_shipping: 'Y' | 'N';
    sale_pincode: number;
    sale_city: string;
    sale_state: string;
    sale_address: string;
    sale_current_status: string;
}
interface CartItem {
    sale_id: string;
    sd_id: number;
    sale_invoice_no: string;
    sale_date: string;
    sale_qty: string;
    sale_price: string;
    sale_total: string;
    sale_discount: string;
    sale_tax: string;
    sale_net_total: number;
    sale_category: string;
    sale_handover_name: string;
    sale_handover_mobile: string;
    sale_employee_id: string;
    sale_reference_name: string;
    sale_reference_mobile: string;
    sale_transaction_id: string;
    sale_status: number;
    sale_is_shipping: string;
    sale_pincode: number;
    sale_address: string;
    sale_pd_id: number;


    sd_product_id: number;
    sd_qty: number;
    sd_amount: number;
    sd_discount: number;
    sd_sub_total: number;
    sd_unit: number;
    sd_mtr: number;
    sd_ledger_id: number;
    sd_sale_type: string;
    sd_manual_job_no: string;
    sd_trail_date: string;
    sd_trail_time: string;
    sd_mobile_no: string;
    sd_delivery_date: string;
    sd_delivery_time: string;
    sd_for_custmor: string;
    sd_pd_id: number;

    product_name: string;
    product_code: string;

    sd_sale_id: string;

    sd_variant_code: string;
    sd_tailor_name: string;
    sd_measurement: string;
    sd_fabric_issued: string;
    category_name: string;
}
interface ProductRow {
    sr: number;
    product: string;
    mtr: number;
    qty: number;
    unit: string;
    rate: number;
    discount: number;
    subtotal: number;
    sd_variant_code: string;
    sd_qty: number;
    sd_unit: number;
}
interface Ledger {
    ledger_id: number;
    ledger_deals_in_company?: number;
    ledger_status?: number;
    ledger_first_name: string;
    ledger_last_name?: string;
    ledger_mobile_no?: string;
    ledger_company_name?: string;
    ledger_gstin?: string;
}
interface InvoicePayload {
    customer: {
        phone: string;
        first_name: string;
        last_name: string;
        company: string;
        gst: string;
        reference: { phone: string; name: string };
        handover: { phone: string; name: string };
        invoiceCategory: string;
        salesEmployee: string;
    };
    items: ProductRow[];
    totalAmount: number;
    saleId?: string; // ✅ Add this

}



const InvoiceUI: React.FC = () => {
    const inputRef = React.useRef<InputRef>(null);
    const { sale_id } = useParams<{ sale_id?: string }>();
    const [discountModalVisible, setDiscountModalVisible] = useState(false);
    const [ledgerId, setLedgerId] = useState<number | null>(null);
    const [discounts, setDiscounts] = useState<any[]>([]);
    const [specialDiscounts, setSpecialDiscounts] = useState<any[]>([]);

    const [paymentModalVisible, setPaymentModalVisible] = useState(false);
    const [showBottomSection, setShowBottomSection] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [clientData, setclientData] = useState<clientItem | null>(null);
    const [cartData, setCart] = useState<CartItem[]>([]);
    const [ledgers, setLedgers] = useState<Ledger[]>([]);
    const [dropdownOptions, setDropdownOptions] = useState<{ label: string; value: number }[]>([]);
    const [saleId, setsaleId] = useState<string | null>(null);

    const [jobModalVisible, setJobModalVisible] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [initialValues, setInitialValues] = useState<CartItem | null>(null);
    const [isPDModalVisible, setIsPDModalVisible] = useState(false);
    const [isPDEditMode, setIsPDEditMode] = useState(false);
    const [initialValuesPD, setInitialValuesPD] = useState<PD | null>(null);


    const [isSubmitEditMode, setIsSubmitEditMode] = useState(false);

    const location = useLocation();
    const [disabledFields, setDisabledFields] = useState<string[]>([]);


    const [cityStateHidden, setCityStateHidden] = useState(true);

    const [form] = Form.useForm();

    const isShipping = Form.useWatch('isShipping', form);
    const [loadingCart, setLoadingCart] = useState(false);

    const [saleStatus, setSaleStatus] = useState<string | null>(null);
    const [formInitialized, setFormInitialized] = useState(false);

    const [selectedRecord, setSelectedRecord] = useState<CartItem | null>(null);
    const [sdPdId, setSdPdId] = useState<number | null>(null);

    const [categories, setCategories] = useState<Categories[]>([]);

    const [currentSaleId, setCurrentSaleId] = useState<number | null>(null);


    const cancel: PopconfirmProps['onCancel'] = (e) => {
        console.log(e);
        showError('Click on No');
    };


    const updateQuantity = (sale_id: string, quantity: number) => {
        if (quantity <= 0) {
            setCart((prev) => prev.filter((item) => item.sale_id !== sale_id));
        } else {
            setCart((prev) =>
                prev.map((item) =>
                    item.sale_id === sale_id ? { ...item, sd_qty: quantity } : item
                )
            );
        }
    };
    // const subtotal = Array.isArray(cartData) && cartData.length
    //     ? cartData.reduce((sum, item) => sum + item.sd_sub_total, 0)
    //     : 0;

    const subtotal = useMemo(() => {
        return Array.isArray(cartData) && cartData.length
            ? cartData.reduce((sum, item) => sum + item.sd_sub_total, 0)
            : 0;
    }, [cartData]);

    const clearCart = () => setCart([]);
    // const handleInputChange = <K extends keyof CartItem>(
    //     value: CartItem[K],
    //     rowIndex: number,
    //     key: K
    // ) => {
    //     const updatedCart = [...cartData];
    //     const itemToUpdate = { ...updatedCart[rowIndex] };

    //     itemToUpdate[key] = value;

    //     // Recalculate subtotal if any of the pricing fields change
    //     if (key === 'sd_qty' || key === 'sd_amount' || key === 'sd_discount') {
    //         const qty = Number(itemToUpdate.sd_qty) || 0;
    //         const rate = Number(itemToUpdate.sd_amount) || 0;
    //         const discount = Number(itemToUpdate.sd_discount) || 0;

    //         const subtotal = qty * rate - discount;
    //         itemToUpdate.sd_sub_total = subtotal >= 0 ? subtotal : 0;
    //     }

    //     updatedCart[rowIndex] = itemToUpdate;
    //     setCart(updatedCart);
    // };



    const handleInputChange = async <K extends keyof CartItem>(
        value: CartItem[K],
        rowIndex: number,
        key: K
    ) => {
        const updatedCart = [...cartData];
        const itemToUpdate = { ...updatedCart[rowIndex] };

        itemToUpdate[key] = value;

        const categoryName = itemToUpdate.category_name || ""; // ✅ category check

        // ✅ Recalculate subtotal if quantity, rate, or discount changes (for display purpose)
        if (key === "sd_qty" || key === "sd_amount" || key === "sd_discount" || key === "sd_mtr") {
            const qty = Number(itemToUpdate.sd_qty) || 0;
            const rate = Number(itemToUpdate.sd_amount) || 0;
            const mtr = Number(itemToUpdate.sd_mtr) || 0;
            const discount = Number(itemToUpdate.sd_discount) || 0;

            // 👇 Fabric के लिए अलग formula
            if (categoryName === "Fabric") {
                itemToUpdate.sd_sub_total = Number((qty * rate * mtr - discount).toFixed(2));
            } else {
                itemToUpdate.sd_sub_total = Number((qty * rate - discount).toFixed(2));
            }
        }

        // ✅ Fabric category logic
        if (categoryName === "Fabric") {
            // If qty, mtr, rate, or discount change — all handled by /update-mtr-cart
            if (["sd_qty", "sd_mtr", "sd_amount", "sd_discount"].includes(key as string)) {
                const newQty = Number(itemToUpdate.sd_qty) || 0;
                const newMtr = Number(itemToUpdate.sd_mtr) || 0;

                try {
                    if (!itemToUpdate.sd_id) {
                        showError("Cannot update Fabric item: invalid sale detail ID");
                        return;
                    }

                    await apiRequest({
                        method: "post",
                        url: `/update-mtr-cart/${itemToUpdate.sd_id}`,
                        data: {
                            mtr: newMtr,
                            qty: newQty, // ✅ backend handles both qty + mtr
                        },
                    });

                    showSuccess("Fabric subtotal updated successfully");
                } catch (err) {
                    console.error(err);
                    showError("Failed to update Fabric subtotal");
                }
            }
        } else {
            // ✅ Non-Fabric category logic
            if (key === "sd_qty") {
                const newQty = Number(itemToUpdate.sd_qty) || 0;

                try {
                    if (!itemToUpdate.sd_id) {
                        showError("Cannot update quantity: invalid sale detail ID");
                        return;
                    }

                    await apiRequest({
                        method: "post",
                        url: `/update-qty-cart/${itemToUpdate.sd_id}`,
                        data: {
                            quantity: newQty,
                        },
                    });

                    showSuccess("Quantity updated successfully");
                } catch (err) {
                    console.error(err);
                    showError("Failed to update quantity");
                }
            }

            // 🚫 Prevent MTR updates for non-Fabric
            if (key === "sd_mtr") {
                showError("MTR update is only applicable for Fabric products");
            }
        }

        // ✅ Update cart state locally
        updatedCart[rowIndex] = itemToUpdate;
        setCart(updatedCart);
    };




    const columns: TableColumnsType<CartItem> = [
        {
            title: '#',
            key: 'index',
            width: 70,
            align: 'center',
            render: (_: any, __: any, index: number) => <div>{index + 1}</div>,
        },
        {
            title: 'Product Details', dataIndex: 'product', key: 'product', width: 350,
            render: (_, record: any) => (
                <span>
                    {record.product_name} ({record.variant_code})
                    {record.sd_variant_code ? ` - ${record.sd_variant_code}` : ''}<br></br>
                    {record.brand_name ? ` - ${record.brand_name}` : ''}
                    {record.category_name ? ` - ${record.category_name}` : ''}
                    {record.bc_name ? ` - ${record.bc_name}` : ''}
                </span>
            ),
        },
        {
            title: 'Mtr',
            dataIndex: 'sd_mtr',
            key: 'sd_mtr',
            render: (_, record, index) => (
                <Input
                    type="number"
                    value={record.sd_mtr}
                    onChange={e => {
                        const val = e.target.value;

                        // Prevent negative sign
                        if (val.startsWith('-')) return;

                        handleInputChange(Number(val), index, 'sd_mtr');
                    }}
                    onKeyDown={e => {
                        // Prevent typing '-'
                        if (e.key === '-') {
                            e.preventDefault();
                        }
                    }}
                    min={0} // optional: restrict negative values
                />
            ),
        },
        {
            title: 'Qty',
            dataIndex: 'sd_qty',
            key: 'sd_qty',
            render: (_, record, index) => (
                <Input
                    type="number"
                    value={record.sd_qty}
                    disabled={loadingCart}
                    min={0} // Prevent negative values via spinner
                    onKeyDown={(e) => {
                        // Prevent typing '-'
                        if (e.key === '-') {
                            e.preventDefault();
                        }
                    }}
                    onChange={(e) => {
                        const val = e.target.value;

                        // Prevent negative value from paste or manual entry
                        if (val.startsWith('-')) return;

                        handleInputChange(Number(val), index, 'sd_qty');
                    }}
                />
            ),
        },
        {
            title: 'Unit',
            dataIndex: 'sd_unit',
            key: 'sd_unit',
            render: (_, record, index) => (
                <Input
                    type="number"
                    value={record.sd_unit}
                    min={0} // Prevent negative values via spinner
                    onKeyDown={(e) => {
                        // Prevent typing '-'
                        if (e.key === '-') {
                            e.preventDefault();
                        }
                    }}
                    onChange={(e) => {
                        const val = e.target.value;

                        // Prevent negative value from paste or manual entry
                        if (val.startsWith('-')) return;

                        handleInputChange(Number(val), index, 'sd_unit');
                    }}
                />
            ),
        },
        {
            title: 'Rate',
            dataIndex: 'sd_amount',
            key: 'sd_amount',
            render: (_, record, index) => (
                <Input
                    type="number"
                    value={record.sd_amount}
                    min={0} // Prevent negative values via spinner
                    onKeyDown={(e) => {
                        // Prevent typing '-'
                        if (e.key === '-') {
                            e.preventDefault();
                        }
                    }}
                    onChange={(e) => {
                        const val = e.target.value;

                        // Prevent negative value from paste or manual entry
                        if (val.startsWith('-')) return;

                        handleInputChange(Number(val), index, 'sd_amount');
                    }}
                />
            ),
        },
        {
            title: 'Discount',
            dataIndex: 'sd_discount',
            key: 'sd_discount',
            render: (_, record, index) => (
                <Input
                    type="number"
                    value={record.sd_discount}
                    min={0} // Prevent negative values via spinner
                    onKeyDown={(e) => {
                        // Prevent typing '-'
                        if (e.key === '-') {
                            e.preventDefault();
                        }
                    }}
                    onChange={(e) => {
                        const val = e.target.value;

                        // Prevent negative value from paste or manual entry
                        if (val.startsWith('-')) return;

                        handleInputChange(Number(val), index, 'sd_discount');
                    }}
                />
            ),
        },
        {
            title: 'Sub Total',
            dataIndex: 'subtotal',
            key: 'subtotal',
            render: (_, record) => (
                <span>{record.sd_sub_total < 0 ? 0 : record.sd_sub_total}</span>
            ),
        },
        {
            title: 'Action',
            key: 'action',
            width: 80,
            render: (_, record) => (
                <Space>
                    {/* <Button danger  icon={<DeleteOutlined 
                    />} /> */}
                    <Popconfirm
                        title="Delete this sale Type?"
                        onConfirm={() => handleDelete(record.sd_id)}
                        onCancel={cancel}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button danger className="px-8">
                            <DeleteOutlined />
                        </Button>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    useBillingShortcuts();
    useEffect(() => {
        const handleProductSearch = () => {
            console.log('Product search opened (F1)');
            inputRef.current?.focus();
        };

        document.addEventListener('shortcut-open-product', handleProductSearch);
        return () => {
            document.removeEventListener('shortcut-open-product', handleProductSearch);
        };
    }, []);
    // when edit 
    // useEffect(() => {
    //     form.setFieldsValue({
    //         invoiceCategory: 'estimate',
    //         phone: '9999999999',
    //         firstName: 'Anjali',
    //         lastName: 'Sharma',
    //         company: 'XYZ Ltd.',
    //         gst: '11AAAAA0000A1Z5',
    //     });
    // }, []);
    const fetchcart = async (
        sale_id_data: string | null = null) => {
        console.log("response.sale_id", sale_id_data)
        try {
            const s_id = saleId || sale_id_data;
            const response = await apiRequest<{
                data: CartItem[];
                sale_id_data: string;
            }>({
                method: 'post',
                url: `/get-to-cart/${s_id}`,
                data: {
                    // id_edit: sale_id_data ? true : false,
                    id_edit: !!sale_id_data
                },
            });
            setCart(response.data)
            console.log("data", response.data);
        } catch {
            showError('Failed to fetch vouchers');
        }
    };

    const insertProductToCart = async (searchValue: string) => {
        if (!searchValue) return;
        if (!clientData) {
            showError('Please enter customer details before searching for a product.');
            return;
        }

        try {
            const response = await apiRequest({
                method: 'post',
                url: `/add-to-cart`,
                data: {
                    product_code: searchValue,
                    ledger_id: clientData.ledger_id
                },
            });
            setsaleId(response.sale_id)
            fetchcart(response.sale_id);

            showSuccess('Product added to cart');
            setSearchText('');
        } catch (error) {
            showError('Product not found or failed to add');
        }
    };

    const handleDelete = async (sd_id: number) => {
        try {
            await apiRequest({
                method: 'delete',
                url: `/delete-to-cart/${sd_id}`,
            });
            showSuccess('Sale Type deleted');
            fetchcart();
        } catch {
            showError('Failed to delete Cart Item');
        }
    };

    // const insertProductToCart = async (searchValue: string) => {
    //     if (!searchValue) return;

    //     if (!clientData) {
    //         showError('Please enter customer details before searching for a product.');
    //         return;
    //     }

    //     try {
    //         const method = saleId ? 'put' : 'post'; // 🧠 Check if editing or adding
    //         const url = saleId ? `/edit-to-cart/${saleId}` : `/add-to-cart`;

    //         const response = await apiRequest({
    //             method,
    //             url,
    //             data: {
    //                 product_code: searchValue,
    //                 ledger_id: clientData.ledger_id,
    //             },
    //         });

    //         if (response?.sale_id && !saleId) {
    //             setsaleId(response.sale_id); // ✅ Set sale_id if it's first time
    //         }

    //         fetchcart(); // ⏬ Refresh cart
    //         showSuccess('Product added to cart');
    //         setSearchText('');
    //     } catch (error) {
    //         console.error(error);
    //         showError('Product not found or failed to add');
    //     }
    // };




    const [dataSource, setDataSource] = useState<ProductRow[]>([1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(i => ({
        sr: i,
        product: `Product ${i}`,
        mtr: 1,
        qty: 2,
        unit: '',
        rate: 200,
        discount: 2,
        subtotal: 400,
        sd_variant_code: '',
        sd_qty: 2,
        sd_unit: 2
    })));

    const tableScrollY = useMemo(() => {
        return showBottomSection ? 'calc(100vh - 629px)' : 'calc(100vh - 357px)';
    }, [showBottomSection]);

    const totalAmount = useMemo(() => {
        return dataSource.reduce((sum, row) => sum + (row.subtotal || 0), 0);
    }, [dataSource]);

    const checkUser = async (
        sale_id: string | null = null) => {
        let mobile = form.getFieldValue('phone');
        let first_name = form.getFieldValue('firstName');
        let last_name = form.getFieldValue('lastName');
        try {
            const response = await apiRequest<{
                data: clientItem;
                sale_id: string;
                sale_current_status: string;
            }>({
                method: 'get',
                url: `/check-client?mobile=${mobile}&first_name=${first_name}&last_name=${last_name}`
            });
            console.log("data", response.data);
            if (response.data) {
                setclientData(response.data);
                setSaleStatus(response.data.sale_current_status);
                form.setFieldsValue({
                    firstName: response.data.ledger_first_name.split(' ')[0] || '',
                    lastName: response.data.ledger_last_name || '',
                    company: response.data.ledger_company_name || '',
                    gst: response.data.ledger_gstin || '',
                });
                setLedgerId(response.data.ledger_id);
            } else {
            }

        } catch {
            showError('Failed to fetch vouchers');
        }
    };

    const debouncedSearchText = useDebounce(searchText);
    useEffect(() => {
        if (debouncedSearchText.trim() !== '') {
            insertProductToCart(debouncedSearchText.trim());
        }
    }, [debouncedSearchText]);

    useEffect(() => {
        fetchLedger();
    }, []);
    useEffect(() => {
        setsaleId(clientData?.active_cart || null);
    }, [clientData?.active_cart]);
    useEffect(() => {
        if (saleId) {
            fetchcart();
        }
    }, [saleId]);

    const handlePayNow = async (paymentResult: { pd_id?: number }) => {
        try {
            // pd_id directly from payment result
            const pdId = handleCreatePM(paymentResult);
            if (!pdId) return; // null check
            // Validate the form
            const formData = await form.validateFields();

            const extractNameParts = (fullName = '') => {
                const [firstName, ...rest] = fullName.trim().split(' ');
                return {
                    ledger_first_name: firstName || null, // required
                    ledger_last_name: rest.join(' ') || null, // optional
                };
            };

            const refPhone = formData.refPhone;
            const refName = formData.refName;
            const handoverPhone = formData.handoverPhone;
            const handoverName = formData.handoverName;

            const refCheck = await checkRefernceUser(refPhone);
            if (!refCheck.exists && refName) {
                const { ledger_first_name, ledger_last_name } = extractNameParts(refName);
                if (ledger_first_name) {
                    await apiRequest({
                        method: 'post',
                        url: 'add-small-ledger',
                        data: {
                            ledger_mobile_no: refPhone,
                            ledger_first_name,
                            ledger_last_name,
                        },
                    });
                }
            }

            const handoverCheck = await checkRefernceUser(handoverPhone);
            if (!handoverCheck.exists && handoverName) {
                const { ledger_first_name, ledger_last_name } = extractNameParts(handoverName);
                if (ledger_first_name) {
                    await apiRequest({
                        method: 'post',
                        url: 'add-small-ledger',
                        data: {
                            ledger_mobile_no: handoverPhone,
                            ledger_first_name,
                            ledger_last_name,
                        },
                    });
                }
            }



            // Prepare payload (basic example)
            const payload = {
                customer: {
                    phone: formData.phone,
                    first_name: formData.firstName,
                    last_name: formData.lastName,
                    company: formData.company,
                    gst: formData.gst,
                    reference: {
                        phone: formData.refPhone,
                        name: formData.refName,
                    },
                    handover: {
                        phone: formData.handoverPhone,
                        name: formData.handoverName,
                    },
                    shipping: {
                        isshipping: formData.isShipping,
                        pincode: formData.ShippingPincode,
                        city: formData.ShippingCity,
                        state: formData.ShippingState,
                        address: formData.ShippingAddress,
                    },
                    invoiceCategory: formData.invoiceCategory,
                    salesEmployee: formData.salesEmployee,
                },
                // items: dataSource,
                items: dataSource.map(item => ({
                    ...item,
                    sd_pd_id: pdId, // UI में भी update
                })),
                totalAmount,
                pd_id: pdId,
            };

            // Make API request
            const response = await apiRequest({
                method: 'post',
                url: '/submit-invoice',
                data: payload,
            });

            showSuccess('Invoice submitted successfully');
            console.log('Response:', response);
            // Optionally reset the form and cart
            form.resetFields();
            setDataSource([]);
            setCart([]);
        } catch (error) {
            showError('Failed to submit invoice');
        }
    };
    // for refernce and handover name number
    const fetchLedger = async (mobile?: string) => {
        try {
            let url = `ledger-data`;
            if (mobile) url += `?mobile=${encodeURIComponent(mobile)}`;

            const response = await apiRequest<{ ledgers: Ledger[] }>({
                method: 'get',
                url,
            });
            console.log("ledger", response);
            const fetched = response.ledgers || [];
            setLedgers(fetched);

            // Map to dropdown options
            const options = fetched.map((ledger) => ({
                label: `${ledger.ledger_first_name} ${ledger.ledger_last_name || ''}`,
                value: ledger.ledger_id,
            }));

            setDropdownOptions(options);

            // Auto-select if only one match
            if (options.length === 1) {
                form.setFieldsValue({
                    handover_full_name: options[0].value,
                });
            } else {
                form.setFieldsValue({ handover_full_name: undefined });
            }

        } catch (error) {
            showError('This Ledger is not Exist');
            console.error(error);
        }
    };

    const handleCreate = (data: { sale_id: string }) => {
        setsaleId(data.sale_id);
        fetchcart();
    };


    // const handleCreatePM = (data: { sale_id: string }) => {
    //     setsaleId(data.sale_id);
    //     fetchcart();
    // };

    // const handleCreatePM = (res: any) => {
    //     if (res?.pd_id) {
    //         setSdPdId(res.pd_id); // ✅ Store pd_id
    //     }
    //     setIsPDModalVisible(false); // ✅ Close modal
    // };

    // useEffect(() => {
    //     console.log("Active cart from clientData:", clientData?.active_cart);
    //     setsaleId(clientData?.active_cart || null);
    // }, [clientData?.active_cart]);




    const handleCreatePM = async (paymentResult: any) => {
        console.log("Payment result received:", paymentResult);
        const pdId = paymentResult?.payment_id;

        if (!pdId) {
            showError("Payment ID not received");
            return;
        }

        // ✅ Derive saleId directly
        const currentSaleId = clientData?.active_cart;
        if (!currentSaleId) {
            showError("No active sale found. Please select a customer or start a sale.");
            return;
        }

        // Validate customer info
        if (!clientData?.ledger_mobile_no || !clientData?.ledger_first_name) {
            showError("Mobile Number and First Name are required for this sale.");
            return;
        }

        try {
            // Backend update (main sale + sale details)
            await apiRequest({
                method: "put",
                url: `update-sale-payment/${currentSaleId}`,
                data: { sale_pd_id: pdId },
            });

            // Update frontend cart
            const updatedCart = cartData.map(item => ({
                ...item,
                sd_pd_id: pdId,
                sale_pd_id: pdId,
            }));

            setCart(updatedCart);
            setIsPDModalVisible(false);
            showSuccess("Payment linked successfully!");
        } catch (error: any) {
            console.error("Payment linking error:", error);
            const message =
                error?.response?.data?.message || "Failed to link payment with sale";
            showError(message);
        }
    };





    const hideCreateModal = () => {
        setIsModalVisible(false);
        setIsEditMode(false);
        setInitialValues(null);
    };

    const hideCreateModalPD = () => {
        setIsPDModalVisible(false);
        setIsPDEditMode(false);
        setInitialValuesPD(null);
    };


    const handleEditClick = (record?: CartItem) => {
        if (!record) {
            showError("No cart data available");
            return;
        }

        setIsEditMode(true);
        setInitialValues({
            ...record, // all cart fields including sd_id and ledger_id
        });

        setIsModalVisible(true);
    };

    // tailor job modal
    const showCreateModal = (record?: CartItem) => {
        // if (!record) {
        //     showError("No cart data available");
        //     return;
        // }

        if (!clientData?.ledger_id) {
            showError("Client data not found. Please enter phone number and fetch client first.");
            return;
        }

        setIsEditMode(false);

        const defaultJobFields = {
            sd_sale_id: record?.sale_id ?? '',
            sd_ledger_id: clientData.ledger_id,
            sd_product_id: record?.sd_product_id ?? 0,
            sd_sale_type: "job",
        };

        setInitialValues({
            ...record,
            ...defaultJobFields,
        } as CartItem);

        setIsModalVisible(true);
    };

    // payment details modal
    // const showPaymentDetailsModal = (record?: CartItem) => {
    //     if (!clientData?.ledger_id) {
    //         showError("Client data not found. Please enter phone number and fetch client first.");
    //         return;
    //     }

    //     const calculatedSubtotal = Array.isArray(cartData) && cartData.length
    //         ? cartData.reduce((sum, item) => sum + item.sd_sub_total, 0)
    //         : 0;


    //     setIsPDEditMode(false);

    //     // ✅ Create PaymentDetails fields from CartItem record
    //     const paymentDefaults: PD = {
    //         // pd_id: 1,
    //         pd_sale_id: Number(record?.sale_id) || undefined,
    //         pd_sd_id: record?.sd_id,
    //         pd_sale_net_total: calculatedSubtotal
    //     };

    //     setInitialValuesPD(paymentDefaults); // ✅ For PD modal
    //     // setIsPDModalVisible(true); // ✅ Open modal0
    //     // थोड़ा delay दो ताकि `initialValues` पहले set हो जाए
    //     setTimeout(() => {
    //         setIsPDModalVisible(true);
    //     }, 0);
    // };

    const showPaymentDetailsModal = (record?: CartItem) => {
        if (!clientData?.ledger_id) {
            showError("Client data not found. Please enter phone number and fetch client first.");
            return;
        }

        const calculatedSubtotal = Array.isArray(cartData) && cartData.length
            ? cartData.reduce((sum, item) => sum + item.sd_sub_total, 0)
            : 0;

        setSelectedRecord(record || null); // ✅ यहां record को state में रख रहे हैं
        setIsPDEditMode(false);
        setInitialValuesPD(null);
        setIsPDModalVisible(true);
    };


    useEffect(() => {
        if (sale_id) {
            setsaleId(sale_id);
        }
    }, [sale_id]);

    // POSPage.tsx या जो भी component sale_id से deal करता है

    useEffect(() => {
        if (sale_id) {
            fetchPaymentDetails(Number(sale_id));  // backend से fetch
        }
    }, [sale_id]);



    const handleEditPaymentDetails = (record: PD, createNew = false) => {
        setIsPDEditMode(!createNew);
        setInitialValuesPD({
            // IDs & references
            pd_id: createNew ? undefined : record.pd_id,
            pd_sale_id: record.pd_sale_id,
            pd_sd_id: record.pd_sd_id,
            pd_sale_transaction_id: record.pd_sale_transaction_id,
            sale_id: record.sale_id,
            sale_transaction_id: record.sale_transaction_id,

            // UPI
            pd_method_upi: record.pd_method_upi,
            pd_upi_transaction_id: record.pd_upi_transaction_id,
            pd_upi_amount: record.pd_upi_amount,

            // Credit Card
            pd_method_cradit_card: record.pd_method_cradit_card,
            pd_cradit_card_number: record.pd_cradit_card_number,
            pd_cradit_card_holder_name: record.pd_cradit_card_holder_name,
            pd_cradit_card_amount: record.pd_cradit_card_amount,

            // Cash coins
            pd_method_cash: record.pd_method_cash,
            pd_1_coin: record.pd_1_coin,
            pd_2_coin: record.pd_2_coin,
            pd_5_coin: record.pd_5_coin,
            pd_10_coin: record.pd_10_coin,
            pd_20_coin: record.pd_20_coin,

            // Cash notes
            pd_10_note: record.pd_10_note,
            pd_20_note: record.pd_20_note,
            pd_50_note: record.pd_50_note,
            pd_100_note: record.pd_100_note,
            pd_200_note: record.pd_200_note,
            pd_500_note: record.pd_500_note,
            pd_cash_amount: record.pd_cash_amount,

            // Totals
            pd_all_total_amount: record.pd_all_total_amount,
            pd_sale_net_total: record.pd_sale_net_total,
            sale_net_total: record.sale_net_total,
        });
        setIsPDModalVisible(true);
    };

    const fetchPaymentDetails = async (saleId: number) => {
        try {
            const res = await apiRequest({
                method: "get",
                url: `get-payment-detail-by-sale/${saleId}`,
            });

            if (res?.data) {
                setInitialValuesPD(res.data);  // backend से fetched data
                setIsPDEditMode(true);         // edit mode चालू
                // setIsPDModalVisible(true);     // modal open
            } else {
                setIsPDEditMode(false);
                // setIsPDModalVisible(true);     // create mode
            }
        } catch (error) {
            console.error("Failed to fetch payment details", error);
        }
    };



    // edit mode
    const fetchClientDataBySaleId = async (saleId: string) => {
        try {
            const response = await apiRequest<{ data: clientItem }>({
                method: 'get',
                url: `/get-all-billing/${saleId}`,
            });

            const data = response.data;

            if (data) {
                setclientData(data);
                // fetchcart(sale_id);
                const fieldsToUpdate: any = {
                    firstName: data.ledger_first_name?.split(' ')[0] || '',
                    lastName: data.ledger_last_name || '',
                    phone: data.ledger_mobile_no || '',
                    company: data.ledger_company_name || '',
                    gst: data.ledger_gstin || '',
                    invoiceCategory: data.invoice_category || '',
                    salesEmployee: data.sale_employee_id || '',
                    isShipping: data.sale_is_shipping || 'N',
                    ShippingPincode: data.sale_pincode || '',
                    ShippingCity: data.sale_city || '',
                    ShippingState: data.sale_state || '',
                    ShippingAddress: data.sale_address || '',
                };

                // Only set these if the API actually has values
                if (data.reference_phone) {
                    fieldsToUpdate.refPhone = data.reference_phone;
                }
                if (data.reference_name) {
                    fieldsToUpdate.refName = data.reference_name;
                }
                if (data.handover_phone) {
                    fieldsToUpdate.handoverPhone = data.handover_phone;
                }
                if (data.handover_name) {
                    fieldsToUpdate.handoverName = data.handover_name;
                }
                form.setFieldsValue(fieldsToUpdate);
            }
        } catch (error) {
            showError('Failed to fetch client data');
        }
    };



    useEffect(() => {
        if (saleId) {
            // Edit mode
            setIsSubmitEditMode(true);
            fetchcart(saleId);
            fetchClientDataBySaleId(saleId);
        } else {
            // Insert mode
            setIsSubmitEditMode(false);

            const valuesToKeep = form.getFieldsValue([
                'firstName',
                'lastName',
                'phone',
                'company',
                'gst',
            ]);

            // form.resetFields(); // reset करता है सभी fields
            setDataSource([]);
            setCart([]);

            // यहां डालें default value 'N'
            form.setFieldsValue({
                ...valuesToKeep,
                isShipping: 'N',
            });
        }
    }, [saleId]);



    useEffect(() => {
        if (location.state?.isEditMode) {
            setIsEditMode(true);
            setDisabledFields(location.state.disableInputs || []);
        }
    }, [location.state]);

    // pincode through search state wise gst apply
    const handlePincodeChange = async (pincode: string) => {
        if (!/^\d{6}$/.test(pincode)) return;

        try {
            const data = await apiRequest<{
                city: string;
                state: string;
                country: string;
            }>({
                method: "get",
                url: `lookup/pincode/${pincode}`,
            });

            form.setFieldsValue({
                ShippingCity: data.city,
                ShippingState: data.state,
            });
        } catch {
            showError("Could not fetch location data");
            form.setFieldsValue({
                ShippingCity: '',
                ShippingState: '',
            });
        }
    };


    // check refenece and handover and if not exist
    const checkRefernceUser = async (
        mobile: string,
        callback?: (fullName: string) => void
    ): Promise<{ exists: boolean; fullName?: string }> => {
        try {
            const response = await apiRequest<{
                data: clientItem;
                sale_id: string;
                sale_current_status: string;
            }>({
                method: 'get',
                url: `/check-client-by-mobile?mobile=${mobile}`,
            });

            if (response.data) {
                const fullName = `${response.data.ledger_first_name || ''} ${response.data.ledger_last_name || ''}`.trim();

                if (callback) callback(fullName);

                setclientData(response.data);
                setSaleStatus(response.data.sale_current_status);

                form.setFieldsValue({
                    firstName: response.data.ledger_first_name?.split(' ')[0] || '',
                    lastName: response.data.ledger_last_name || '',
                });

                return { exists: true, fullName };
            } else {
                return { exists: false };
            }
        } catch (err) {
            console.error(err);
            return { exists: false };
        }
    };


    useEffect(() => {
        if (!formInitialized) {
            form.setFieldsValue({
                refPhone: '',
                refName: ''
            });
            setFormInitialized(true);
        }
    }, []);


    const fetchLedgerDiscounts = async (ledgerId: number) => {
        try {
            const res = await apiRequest({
                method: 'get',
                url: `/ledger-category-mapping?ledger_id=${ledgerId}`,
            });
            console.log("res of discount data", res)
            setDiscounts(res);
        } catch (err) {
            console.error(err);
            showError('Failed to fetch discounts');
        }
    };




    return (
        <>
            <Form key={saleId || 'new'} layout="vertical" form={form} onFinish={handlePayNow}>
                {/* Top Row - 5 Items */}
                <Row gutter={16}>
                    {/* Invoice Category */}
                    <Col span={4}>
                        <Form.Item name="invoiceCategory" label="Invoice Category" rules={[{ required: true }]}>
                            <Select placeholder="Select category" disabled={disabledFields.includes('invoiceCategory')}>
                                <Option value="Invoice">Invoice</Option>
                                <Option value="Estimate">Estimate</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    {/* Phone Number */}
                    <Col span={4}>
                        <Form.Item
                            name="phone"
                            label="Phone Number"
                            rules={[
                                { required: true, message: 'Required' },
                                { len: 10, message: 'Enter 10 digits' }
                            ]}

                        >
                            <Input
                                maxLength={10}
                                disabled={disabledFields.includes('phone')}
                                onBlur={(e) => checkUser(e.target.value)}
                                placeholder="Enter Phone Number"
                                onKeyDown={(e) => {
                                    const allowedKeys = [
                                        'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
                                        'ArrowLeft', 'ArrowRight', 'Home', 'End'
                                    ];

                                    // Allow ctrl/cmd + C/V/X/A (copy, paste, cut, select all)
                                    if ((e.ctrlKey || e.metaKey) && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase())) {
                                        return;
                                    }

                                    if (allowedKeys.includes(e.key)) return;

                                    // Allow only number keys
                                    if (!/^\d$/.test(e.key)) {
                                        e.preventDefault();
                                    }
                                }}
                                onPaste={(e) => {
                                    const paste = e.clipboardData.getData('text');
                                    if (!/^\d+$/.test(paste)) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Row gutter={8}>
                            {/* first name */}
                            <Col span={12}>
                                <Form.Item
                                    name="firstName"
                                    label="First Name"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please enter your first name'
                                        },
                                        {
                                            pattern: /^[A-Za-z]+$/, // Only letters allowed
                                            message: 'Only alphabetic characters are allowed'
                                        }
                                    ]}
                                >
                                    <Input
                                        disabled={disabledFields.includes('firstName')}
                                        placeholder="Enter your first name"
                                        onKeyDown={(e) => {
                                            const allowedKeys = [
                                                'Backspace', 'Delete', 'Tab', 'Escape',
                                                'ArrowLeft', 'ArrowRight', 'Home', 'End'
                                            ];

                                            // Allow ctrl/cmd + C/V/X/A (copy, paste, cut, select all)
                                            if ((e.ctrlKey || e.metaKey) && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase())) {
                                                return;
                                            }

                                            if (allowedKeys.includes(e.key)) return;

                                            // Allow only letters a-z or A-Z
                                            if (!/^[a-zA-Z]$/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                        onPaste={(e) => {
                                            const paste = e.clipboardData.getData('text');
                                            if (!/^[a-zA-Z]+$/.test(paste)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            {/* last name */}
                            <Col span={12}>
                                <Form.Item
                                    name="lastName"
                                    label="Last Name"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please enter your last name'
                                        },
                                        {
                                            pattern: /^[A-Za-z]+$/, // Only letters allowed
                                            message: 'Only alphabetic characters are allowed'
                                        }
                                    ]}
                                >
                                    <Input
                                        disabled={disabledFields.includes('lastName')}
                                        placeholder="Enter your last name"
                                        onKeyDown={(e) => {
                                            const allowedKeys = [
                                                'Backspace', 'Delete', 'Tab', 'Escape',
                                                'ArrowLeft', 'ArrowRight', 'Home', 'End'
                                            ];

                                            // Allow ctrl/cmd + C/V/X/A (copy, paste, cut, select all)
                                            if ((e.ctrlKey || e.metaKey) && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase())) {
                                                return;
                                            }

                                            if (allowedKeys.includes(e.key)) return;

                                            // Allow only letters a-z or A-Z
                                            if (!/^[a-zA-Z]$/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                        onPaste={(e) => {
                                            const paste = e.clipboardData.getData('text');
                                            if (!/^[a-zA-Z]+$/.test(paste)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                    {/* company name */}
                    <Col span={6}>
                        <Form.Item
                            name="company"
                            label="Company Name"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter your company name'
                                },
                                {
                                    pattern: /^[A-Za-z\s]+$/, // Only letters and spaces allowed
                                    message: 'Only alphabetic characters are allowed'
                                }
                            ]}
                        >
                            <Input
                                maxLength={100}
                                disabled={disabledFields.includes('company')}
                                placeholder="Enter your company name"
                                onKeyDown={(e) => {
                                    const allowedKeys = [
                                        'Backspace', 'Delete', 'Tab', 'Escape',
                                        'ArrowLeft', 'ArrowRight', 'Home', 'End',
                                    ];

                                    // Allow ctrl/cmd + C/V/X/A (copy, paste, cut, select all)
                                    if ((e.ctrlKey || e.metaKey) && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase())) {
                                        return;
                                    }

                                    if (allowedKeys.includes(e.key)) return;

                                    // Allow only letters a-z, A-Z and space
                                    if (!/^[a-zA-Z\s]$/.test(e.key)) {
                                        e.preventDefault();
                                    }
                                }}
                                onPaste={(e) => {
                                    const paste = e.clipboardData.getData('text');
                                    if (!/^[a-zA-Z\s]+$/.test(paste)) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                        </Form.Item>
                    </Col>
                    {/* GST */}
                    <Col span={4}>
                        <Form.Item
                            name="gst"
                            label="GST No."
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter your GST number'
                                },
                                {
                                    pattern: /^[A-Za-z0-9]+$/, // Only letters and numbers allowed
                                    message: 'Only letters and numbers are allowed'
                                }
                            ]}
                        >
                            <Input
                                maxLength={15}
                                disabled={disabledFields.includes('gst')}
                                placeholder="Enter GST Number"
                                onKeyDown={(e) => {
                                    const allowedKeys = [
                                        'Backspace', 'Delete', 'Tab', 'Escape',
                                        'ArrowLeft', 'ArrowRight', 'Home', 'End', 'Enter'
                                    ];

                                    // Allow ctrl/cmd + C/V/X/A (copy, paste, cut, select all)
                                    if ((e.ctrlKey || e.metaKey) && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase())) {
                                        return;
                                    }

                                    if (allowedKeys.includes(e.key)) return;

                                    // Allow only letters a-z, A-Z and numbers 0-9
                                    if (!/^[a-zA-Z0-9]$/.test(e.key)) {
                                        e.preventDefault();
                                    }
                                }}
                                onPaste={(e) => {
                                    const paste = e.clipboardData.getData('text');
                                    if (!/^[a-zA-Z0-9]+$/.test(paste)) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                {/* Second Row */}
                <Row gutter={16} align="middle" style={{ marginBottom: 16 }}>
                    <Col span={10}>
                        <Input prefix={<SearchOutlined />} ref={inputRef}
                            placeholder="Search product..."
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            allowClear />
                    </Col>
                    <Col span={7}>
                        <Form.Item name="salesEmployee" label="Sales Employee" rules={[
                            {
                                required: true,
                                message: 'Please select Sales Employee'
                            },
                        ]}>
                            <Select placeholder="Select employee"
                                disabled={disabledFields.includes('salesEmployee')}
                                showSearch options={dropdownOptions}
                                filterOption={(input, option) =>
                                    typeof option?.label === 'string' &&
                                    option.label.toLowerCase().includes(input.toLowerCase())
                                }>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={7}>
                        <Space>
                            {/* <Button onClick={() => setDiscountModalVisible(true)}
                                disabled={cartData.length === 0} >Discounts</Button> */}
                            {/* <Button
                                type="primary"
                                onClick={() => setDiscountModalVisible(true)}
                                >
                                Discounts
                                </Button> */}
                            <Button
                                type="primary"
                                disabled={!ledgerId} // 🚫 disable until a client is found
                                onClick={async () => {
                                    if (ledgerId) {
                                        await fetchLedgerDiscounts(ledgerId);
                                        setDiscountModalVisible(true);
                                    } else {
                                        showError('Please enter a valid mobile number first');
                                    }
                                }}
                            >
                                Discounts
                            </Button>


                            <Button
                                type="primary"
                                onClick={() => showCreateModal(cartData[0])}
                            > Add Job</Button>

                            {/* <Button
                                type="primary"
                                onClick={() => showPaymentDetailsModal(cartData[0])}
                                disabled={!cartData[0]?.sale_id}
                            > Payment Details </Button> */}
                            <Button
                                type="primary"
                                onClick={() => {
                                    const record = cartData[0];
                                    if (!record?.sale_id) return;

                                    // Convert CartItem to PD shape
                                    const pdRecord: PD = {
                                        pd_sale_id: Number(record.sale_id),
                                        pd_sd_id: record.sd_id,
                                        pd_sale_transaction_id: record.sale_transaction_id,
                                        sale_id: Number(record.sale_id),
                                        sale_transaction_id: record.sale_transaction_id,
                                        pd_sale_net_total: record.sale_net_total,
                                        sale_net_total: record.sale_net_total,
                                        // If pd_id exists, include it for edit
                                        pd_id: (record as any).pd_id,
                                    };

                                    if (pdRecord.pd_id) {
                                        handleEditPaymentDetails(pdRecord); // Edit mode
                                    } else {
                                        showPaymentDetailsModal(record); // Add mode
                                    }
                                }}
                                disabled={!cartData[0]?.sale_id}
                            >
                                Payment Details
                            </Button>

                        </Space>
                    </Col>
                </Row>

                {/* Table */}
                <div style={{ maxHeight: tableScrollY, minHeight: tableScrollY, overflowY: 'auto', marginBottom: 16 }}>
                    <Table<CartItem>
                        sticky
                        columns={columns}
                        dataSource={cartData}
                        pagination={false}
                        rowKey="sr"
                        bordered
                        scroll={{ y: tableScrollY }}
                    />
                </div>

                {/* Toggle Button */}
                <Row justify="space-between" align="middle" style={{ marginTop: 4 }}>
                    <Col>
                        {!showBottomSection && (
                            <Title level={4} style={{ margin: 0 }}>
                                Total Amount: ₹{subtotal.toFixed(2)}
                            </Title>
                        )}
                    </Col>
                    <Col>
                        <Button
                            type="link"
                            onClick={() => setShowBottomSection(prev => !prev)}
                            icon={showBottomSection ? <CaretUpOutlined /> : <CaretDownOutlined />}
                        >
                            {showBottomSection ? 'Hide Details' : 'Show Details'}
                        </Button>
                    </Col>
                </Row>



                {/* Bottom Section */}
                {showBottomSection && (
                    <>
                        {/* Reference and Handover Section */}
                        <Row gutter={16} style={{ marginTop: 16 }}>
                            <Col span={8}>
                                {/* Reference Phone */}
                                <Form.Item name="refPhone" label="Reference Phone" >
                                    <Input
                                        maxLength={10}
                                        placeholder="Enter Reference Phone"
                                        onChange={(e) => {
                                            const value = e.target.value;

                                            if (/^\d{10}$/.test(value)) {
                                                checkRefernceUser(value, (fullName) => {
                                                    form.setFieldsValue({ refName: fullName }); // ✅ केवल refName को set करें
                                                });
                                            }
                                        }}
                                        onKeyDown={(e) => {
                                            const allowedKeys = [
                                                'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
                                                'ArrowLeft', 'ArrowRight', 'Home', 'End'
                                            ];

                                            // Allow ctrl/cmd + C/V/X/A (copy, paste, cut, select all)
                                            if ((e.ctrlKey || e.metaKey) && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase())) {
                                                return;
                                            }

                                            if (allowedKeys.includes(e.key)) return;

                                            // Allow only number keys
                                            if (!/^\d$/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                        onPaste={(e) => {
                                            const paste = e.clipboardData.getData('text');
                                            if (!/^\d+$/.test(paste)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                </Form.Item>

                                {/* Reference Name */}
                                <Form.Item
                                    name="refName"
                                    label="Reference Name"
                                    rules={[
                                        { pattern: /^[A-Za-z\s]+$/, message: 'Only alphabetic characters and spaces are allowed' }
                                    ]}

                                >
                                    <Input
                                        placeholder="Enter Reference Name"
                                        onKeyDown={(e) => {
                                            const allowedKeys = [
                                                'Backspace', 'Delete', 'Tab', 'Escape',
                                                'ArrowLeft', 'ArrowRight', 'Home', 'End'
                                            ];

                                            // Allow ctrl/cmd + C/V/X/A
                                            if ((e.ctrlKey || e.metaKey) && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase())) {
                                                return;
                                            }

                                            if (allowedKeys.includes(e.key)) return;

                                            // Only letters a-z or A-Z
                                            if (!/^[a-zA-Z]$/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                        onPaste={(e) => {
                                            const paste = e.clipboardData.getData('text');
                                            if (!/^[a-zA-Z]+$/.test(paste)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                {/* Phone (Handover To Through) */}
                                <Form.Item name="handoverPhone" label="Phone (Handover To Through)" >
                                    <Input
                                        maxLength={10}
                                        placeholder="Enter (Handover To Through) Phone"
                                        onChange={(e) => {
                                            const value = e.target.value;

                                            if (/^\d{10}$/.test(value)) {
                                                checkRefernceUser(value, (fullName) => {
                                                    form.setFieldsValue({ handoverName: fullName });
                                                });
                                            }
                                        }}
                                        onKeyDown={(e) => {
                                            const allowedKeys = [
                                                'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
                                                'ArrowLeft', 'ArrowRight', 'Home', 'End'
                                            ];

                                            // Allow ctrl/cmd + C/V/X/A (copy, paste, cut, select all)
                                            if ((e.ctrlKey || e.metaKey) && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase())) {
                                                return;
                                            }

                                            if (allowedKeys.includes(e.key)) return;

                                            // Allow only number keys
                                            if (!/^\d$/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                        onPaste={(e) => {
                                            const paste = e.clipboardData.getData('text');
                                            if (!/^\d+$/.test(paste)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />

                                </Form.Item>

                                {/* Full Name */}
                                <Form.Item
                                    name="handoverName"
                                    label="Full Name"
                                    rules={[
                                        { pattern: /^[A-Za-z\s]+$/, message: 'Only alphabetic characters are allowed' } // Space allowed for full names
                                    ]}
                                >
                                    <Input
                                        placeholder="Enter Full Name"
                                        onKeyDown={(e) => {
                                            const allowedKeys = [
                                                'Backspace', 'Delete', 'Tab', 'Escape',
                                                'ArrowLeft', 'ArrowRight', 'Home', 'End'
                                            ];

                                            // Allow ctrl/cmd + C/V/X/A
                                            if ((e.ctrlKey || e.metaKey) && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase())) {
                                                return;
                                            }

                                            if (allowedKeys.includes(e.key)) return;

                                            // Allow only letters a-z, A-Z and space
                                            if (!/^[a-zA-Z ]$/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                        onPaste={(e) => {
                                            const paste = e.clipboardData.getData('text');
                                            if (!/^[a-zA-Z\s]+$/.test(paste)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item name="isShipping" label="Shipping" rules={[{ required: true }]}>
                                    <Select placeholder="Select Shipping" >
                                        <Option value="Y">Yes</Option>
                                        <Option value="N">No</Option>
                                    </Select>
                                </Form.Item>
                                {isShipping === 'Y' && (
                                    <>
                                        <Form.Item
                                            name="ShippingPincode"
                                            label="Shipping Pincode"
                                            rules={[{ required: true, message: 'Please enter pincode' }]}
                                        >
                                            <Input
                                                maxLength={6}
                                                placeholder="Enter Pincode"
                                                onBlur={(e) => handlePincodeChange(e.target.value)}
                                                onKeyDown={(e) => {
                                                    const allowedKeys = [
                                                        'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
                                                        'ArrowLeft', 'ArrowRight', 'Home', 'End', '.'
                                                    ];

                                                    // Allow control keys
                                                    if (allowedKeys.includes(e.key)) return;

                                                    // Allow only digits
                                                    if (!/^\d$/.test(e.key)) {
                                                        e.preventDefault();
                                                    }

                                                    // Optionally, if you want to allow only digits without dot, remove '.' from allowedKeys
                                                }}
                                                onPaste={(e) => {
                                                    const paste = e.clipboardData.getData('text');
                                                    // Allow only digits (and optionally dot if you want)
                                                    if (!/^\d*$/.test(paste)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </Form.Item>

                                        <Form.Item
                                            name="ShippingCity"
                                            label="Shipping City"
                                            rules={[{ required: true, message: 'Please enter city' }]}
                                            style={{ display: cityStateHidden ? 'none' : 'block' }}
                                        >
                                            <Input readOnly />
                                        </Form.Item>

                                        <Form.Item
                                            name="ShippingState"
                                            label="Shipping State"
                                            rules={[{ required: true, message: 'Please enter state' }]}
                                            style={{ display: cityStateHidden ? 'none' : 'block' }}
                                        >
                                            <Input readOnly />
                                        </Form.Item>

                                        <Form.Item
                                            name="ShippingAddress"
                                            label="Shipping Address"
                                            rules={[{ required: true, message: 'Please enter address' }]}
                                        >
                                            <Input maxLength={200} />
                                        </Form.Item>
                                    </>
                                )}
                                <Title level={4}>Total Amount: ₹{subtotal.toFixed(2)}</Title>
                            </Col>
                        </Row>
                    </>
                )}
                {/* Footer Buttons */}
                <Row justify="end" gutter={16} style={{ marginTop: 24 }}>
                    <Col>
                        <Button icon={<PrinterOutlined />}
                            disabled={saleStatus !== 'active'}>
                            Print
                        </Button>
                    </Col>
                    <Col>
                        <Button danger onClick={() => window.location.reload()}>
                            Clear Cart
                        </Button>
                    </Col>
                    <Col>
                        <Button type="primary" htmlType="submit">Pay Now</Button>
                    </Col>
                </Row>

                {/* Modals */}
                <DiscountModal
                    open={discountModalVisible}
                    onCancel={() => setDiscountModalVisible(false)}
                    onOk={() => setDiscountModalVisible(false)}
                    categories={categories}
                    // categories={form.getFieldValue("categories")}
                    form={form}
                    ledgerId={ledgerId}
                    discounts={discounts}
                    setDiscounts={setDiscounts}
                />


                <AddJobModal
                    visible={isModalVisible}
                    onCancel={hideCreateModal}
                    onCreate={handleCreate}
                    isEditMode={isEditMode}
                    initialValues={initialValues}
                />

                <PaymentDetails
                    visible={isPDModalVisible}
                    onCancel={hideCreateModalPD}
                    onCreate={handleCreatePM}
                    isEditMode={isPDEditMode}
                    initialValues={initialValuesPD}
                    pd_sale_id={Number(selectedRecord?.sale_id) || undefined}
                    pd_sd_id={Number(selectedRecord?.sd_id) || undefined}
                    subtotal={subtotal}
                />
            </Form>
        </>
    );
};

export default InvoiceUI;
